import { SortDescriptor } from '@progress/kendo-data-query'
import {
  IntroducingBrokerFilterKey,
  IntroducingBrokerKey,
} from 'api/Trading-Accounts/Types/IntroducingBrokerDto'

export const normalizeIntroducingBrokersSortQuery = (
  sortDescriptors: SortDescriptor[]
): SortDescriptor[] =>
  sortDescriptors
    .map((x) => {
      if (x.field === IntroducingBrokerKey.name) {
        return { ...x, field: IntroducingBrokerFilterKey.name }
      }
      if (x.field === IntroducingBrokerKey.status) {
        return { ...x, field: IntroducingBrokerFilterKey.status }
      }
      if (x.field === IntroducingBrokerKey.client) {
        return { ...x, field: IntroducingBrokerFilterKey.client }
      }
      if (x.field === IntroducingBrokerKey.tickmillCompany) {
        return { ...x, field: IntroducingBrokerFilterKey.tickmillCompany }
      }
      return x
    })
    .filter((x) => !!x)
